import { getI18n } from '@/plugins/i18n'

import * as dataGridColumn from '@/composables/data-grid-column'
import * as dataGrid from '@/composables/data-grid'

import { useRegistryStore } from '@/stores/registry.store'
import { useGarageStore } from '@/stores/garage.store'

export const useColumns = (currency) => {
  const i18n = getI18n()
  const registryStore = useRegistryStore()
  const garageStore = useGarageStore()

  return [
    {
      dataField: 'date',
      caption: i18n.t('common.documentDate'),
      dataType: 'date', width: '14rem'
    },
    {
      dataField: 'series',
      caption: i18n.t('common.numerationType'),
      dataType: 'string'
    },
    {
      dataField: 'number_mnemonic',
      caption: i18n.t('common.number'),
      dataType: 'number',
      width: '14rem'
    },
    {
      dataField: 'subject_ref',
      caption: i18n.t('common.subject'),
      lookup: dataGrid.useLookup({ store: registryStore.getSubjects()}),
      allowSorting: true,
      allowFiltering: true
    },
    {
      dataField: 'document_ref',
      caption: i18n.t('common.subjectDocument'),
      cellTemplate: 'documentRef',
      editable: false,
      sortable: false
    },
    {
      dataField: 'intervention_type_ref',
      caption: i18n.t('common.interventionType'),
      lookup: dataGrid.useLookup({ store: garageStore.getLocalizedInterventionTypes() }),
      editorOptions: { placeholder: '' }
    },
    dataGridColumn.useTotalNoVatColumn({ currency }),
    dataGridColumn.useTotalVatColumn({ currency }),
    {
      dataField: 'partial_km',
      caption: i18n.t('common.km'),
    },
  ]
}
